// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3fmci","paramInput":"JobSimulator_paramInput__y5mZD","input":"JobSimulator_input__3wPJp"};